<app-dashboard-table-card
  title="Ultima concurrencia"
  icon="event_available"
  accentColor="#1976d2"
  [rows]="members"
  [columns]="columns"
  [isLoading]="isLoading"
  [errorMessage]="errorMessage"
  emptyIcon="event_busy"
  emptyMessage="No hay miembros para mostrar"
  [pageSize]="pageSize"
  [showFooter]="!isLoading && members.length > pageSize"
  (rowClick)="navigateToMember($event.personId)"
  (retry)="retryLoad.emit()">
</app-dashboard-table-card>
